import { ChangeDetectionStrategy, Component, ViewEncapsulation, OnInit, inject } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { IOnboardingEditItem, ISyncOnboardingEditItem, ISyncOnboarding } from '../fi-onboarding';
import { FiOnboardingBuilderHelperService } from '../fi-onboarding-builder-helper.service';
import { FiUserDataService } from '@fi-app/shared/fi-shared-services/fi-user-data.service';
import { OnboardingCreationTypes } from '../onboarding-creation-types';
import { ObjectTypes } from '@fi-shared/types';
import { FiOnboardingService } from '../fi-onboarding.service';
import { isDefined } from '@fi-app/shared/utils';
import { FiCustomerDataService } from '@fi-app/shared/fi-shared-services/fi-customer-data.service';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';

export interface IOnboardingAddDialogResult {
    onboarding: IOnboardingEditItem | ISyncOnboardingEditItem;
    isDefaultOnboarding: boolean;
}

@Component({
    selector: 'fi-onboarding-add-dialog',
    templateUrl: './fi-onboarding-add-dialog.component.html',
    styleUrls: ['./fi-onboarding-add-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-onboarding-add-dialog' },
    standalone: false,
})
export class FiOnboardingAddDialogComponent
    extends FiDialogsContentBase<void, IOnboardingAddDialogResult>
    implements OnInit
{
    private readonly fiOnboardingBuilderHelperService = inject(FiOnboardingBuilderHelperService);
    private readonly fiUserDataService = inject(FiUserDataService);
    private readonly fiOnboardingService = inject(FiOnboardingService);
    private readonly fiCustomerDataService = inject(FiCustomerDataService);

    protected readonly preferredContentLanguage: number = this.fiUserDataService.getContentLanguage();
    protected regularOnboarding: IOnboardingEditItem = this.fiOnboardingBuilderHelperService.getNewOnboardingInstance();
    protected syncOnboarding: ISyncOnboardingEditItem =
        this.fiOnboardingBuilderHelperService.getNewSyncOnboardingInstance();
    protected readonly onboardingCreationTypeOptions =
        this.fiOnboardingBuilderHelperService.onboardingCreationTypeOptions;

    protected currentOnboardingCreationType: OnboardingCreationTypes = OnboardingCreationTypes.Default;
    protected readonly OnboardingCreationTypes = OnboardingCreationTypes;

    protected isSyncOnboardingEnabled: boolean = this.fiCustomerDataService.isSynchronizedOnboardingEnabled();
    protected syncReadyOnboardings: INameIdObj[] = undefined;

    ngOnInit() {
        // todo for tests
        //this.currentOnboardingCreationType = OnboardingCreationTypes.Connection;
        //this.onOnboardingCreationTypeChange();
    }

    protected onOnboardingCreationTypeChange(): void {
        if (this.isDefaultOnboarding()) {
            this.regularOnboarding = this.fiOnboardingBuilderHelperService.getNewOnboardingInstance();
        } else {
            this.syncOnboarding = this.fiOnboardingBuilderHelperService.getNewSyncOnboardingInstance();
            if (!isDefined(this.syncReadyOnboardings)) {
                this.loadSyncCategoryOnboardings();
            }
        }
    }

    private loadSyncCategoryOnboardings(): void {
        this.fiOnboardingService.getSyncReadyOnboardings().then((result) => {
            this.syncReadyOnboardings = result;
        });
    }

    public isYesButtonDisabled(): boolean {
        if (this.isDefaultOnboarding()) {
            return !this.regularOnboarding.Names.find(
                (name) => name.ContentLanguageId === this.preferredContentLanguage,
            )?.Value?.trim().length;
        } else {
            return (
                !isDefined(this.syncOnboarding.MasterOnboardingId) ||
                !isDefined(this.syncOnboarding.ConnectedOnboardingId)
            );
        }
    }

    private getOnboardingToSave(): IOnboardingEditItem | ISyncOnboardingEditItem {
        if (this.isDefaultOnboarding()) {
            return this.regularOnboarding;
        } else {
            return this.syncOnboarding;
        }
    }

    protected isDefaultOnboarding(): boolean {
        return this.currentOnboardingCreationType === OnboardingCreationTypes.Default;
    }

    public getResult(): IOnboardingAddDialogResult {
        return {
            onboarding: this.getOnboardingToSave(),
            isDefaultOnboarding: this.isDefaultOnboarding(),
        };
    }

    protected readonly ObjectTypes = ObjectTypes;
}
